import { MessageChannel } from "@prisma/client";
import { LocalStorageKey } from "@/app/vars/Storage";

type StoredSelection = Partial<Record<MessageChannel, Record<string, number>>>;

export class USequenceVariant {
  public static read(channel: MessageChannel): Record<string, number> {
    return USequenceVariant.readAll()[channel] ?? {};
  }

  public static select(channel: MessageChannel, stepType: string, variantId: number): void {
    const all = USequenceVariant.readAll();

    USequenceVariant.write({
      ...all,
      [channel]: { ...(all[channel] ?? {}), [stepType]: variantId },
    });
  }

  // A stored id survives a regeneration that dropped the variant it points at, so every
  // read is validated against the variants actually on screen.
  public static resolve(
    channel: MessageChannel,
    stepType: string,
    variantIds: number[],
  ): number | null {
    const stored = USequenceVariant.read(channel)[stepType];

    return stored !== undefined && variantIds.includes(stored) ? stored : null;
  }

  private static readAll(): StoredSelection {
    if (typeof window === "undefined") {
      return {};
    }

    try {
      const raw = window.localStorage.getItem(LocalStorageKey.MESSAGES_CONTENT_SELECTED_VARIANTS);

      return raw ? (JSON.parse(raw) as StoredSelection) : {};
    } catch {
      return {};
    }
  }

  private static write(selection: StoredSelection): void {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(
      LocalStorageKey.MESSAGES_CONTENT_SELECTED_VARIANTS,
      JSON.stringify(selection),
    );
  }
}
